export type DiscreetShortcutItem = {
  id: string;
  label: string;
  description: string;
  hidden?: boolean;
};

export const DISCREET_SHORTCUTS_TRIGGER_LABEL = 'Shortcuts';
export const DISCREET_SHORTCUTS_TITLE = 'Shortcuts';
export const DISCREET_SHORTCUTS_SUBTITLE =
  'Open the next useful action without digging around or leaving a bulky panel on screen.';

export function getVisibleDiscreetShortcutItems<T extends DiscreetShortcutItem>(items: T[]): T[] {
  return items.filter((item) => !item.hidden);
}
